import { createMuiTheme } from '@material-ui/core'

export const theme = createMuiTheme({
    palette:{
        primary:{
            main: '#3D899F'
        }
    }
});